<div class="tags-filter">
    <div class="ng-flex">
        <div class="tags-filter__heading">
            <div class="tags-filter__title">Предпочтения</div>
            <button *ngIf="hasSelectedFilter()"
                    type="button"
                    class="tags-filter__reset"
                    (click)="resetFilter()">
                Сбросить
            </button>
        </div>
        <div class="tags-filter__counter">Выбрано {{ selectedTagCount }} из {{ allowTagCount }}</div>
    </div>
    <div class="tags-filter__counter-bar">
        <span class="progress" [style.width.%]="selectedTagProgress"></span>
    </div>
    <div class="tags-filter__list" #tagList>
        @for (tag of tags; track tag.id) {
            <button type="button" #tagButton
                    class="tag"
                    [class.active]="isActiveTag(tag.id)"
                    [disabled]="isTagDisabled(tag.id)"
                    [class.hide]="$index >= visibleTagsCount && !isShowMoreTags"
                    (click)="selectTag(tag.id)">
                {{ tag.name }}
            </button>
        }
    </div>
    @if (tags.length > visibleTagsCount) {
        <button type="button" class="btn-show-more-tags"
                [attr.aria-expanded]="isShowMoreTags"
                [class.down]="isShowMoreTags"
                (click)="showMoreTags()">
            {{ showMoreTagsLabel }}
        </button>
    }
</div>
